import getById from 'utils/DOM/getById'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import clickEventName from 'utils/DOM/clickEventName'
import addEventListener from 'utils/DOM/addEventListener'

const alertTemplate = getById('template-alert')
const alert = alertTemplate ? Templater(alertTemplate.innerText) : undefined

function renderAlert({ id, message, type, closeText, closeEvent }) {
  const alertWrap = getById('alert-wrap')

  if (!alert) {
    return
  }

  alertWrap.innerHTML = alert({
    id,
    message,
    cssClass: `alert--${type}`,
    closeText,
    type
  })

  if (closeEvent) {
    addEventListener(
      id ? `#${id}-close-button` : '#close-button',
      clickEventName,
      closeEvent
    )
  }
}

export default renderAlert
